// @ts-check
import ReferralConfirmationPage from './ReferralConfirmationPage';

export default ReferralConfirmationPage;
